export const EMPLOYER_NETWORK_REPORT_TITLE = 'Employer Network Report'
export const EMPLOYER_NETWORK_BENCHMARKING_AND_DISRUPTION_TITLE = 'Network Benchmarking and Disruption'
export const EMPLOYER_NETWORK_REPORT_RUN_CONFIG_PERSIST_KEY = 'employer-network-report-run-config-v1'
export const LEGACY_RUN_CONFIG_PERSIST_KEY = 'network-benchmarking-run-config-v1'
export const EMPLOYER_NETWORK_REPORT_DELIVERY_BUCKETS = {
    DEV: 'serif-delivery-dev',
    PROD: 'serif-delivery',
    STAGE: 'serif-delivery-staging',
}

export const getEmployerNetworkReportBucket = (env) => {
    const environment = env?.toUpperCase()
    const bucketKey = { DEVELOPMENT: 'DEV', PRODUCTION: 'PROD', STAGING: 'STAGE' }[environment] || environment
    return EMPLOYER_NETWORK_REPORT_DELIVERY_BUCKETS[bucketKey] || 'serif-delivery-dev'
}

export const EMPLOYER_NETWORK_REPORT_BUCKET = getEmployerNetworkReportBucket(import.meta.env.VITE_APP_ENV)

export const TARGET_GEOGRAPHY_MODES = [
    { id: 'national', name: 'National' },
    { id: 'state', name: 'State Specific' },
]

export const US_STATE_OPTIONS = [
    { value: 'AL', name: 'Alabama' },
    { value: 'AK', name: 'Alaska' },
    { value: 'AZ', name: 'Arizona' },
    { value: 'AR', name: 'Arkansas' },
    { value: 'CA', name: 'California' },
    { value: 'CO', name: 'Colorado' },
    { value: 'CT', name: 'Connecticut' },
    { value: 'DE', name: 'Delaware' },
    { value: 'FL', name: 'Florida' },
    { value: 'GA', name: 'Georgia' },
    { value: 'HI', name: 'Hawaii' },
    { value: 'ID', name: 'Idaho' },
    { value: 'IL', name: 'Illinois' },
    { value: 'IN', name: 'Indiana' },
    { value: 'IA', name: 'Iowa' },
    { value: 'KS', name: 'Kansas' },
    { value: 'KY', name: 'Kentucky' },
    { value: 'LA', name: 'Louisiana' },
    { value: 'ME', name: 'Maine' },
    { value: 'MD', name: 'Maryland' },
    { value: 'MA', name: 'Massachusetts' },
    { value: 'MI', name: 'Michigan' },
    { value: 'MN', name: 'Minnesota' },
    { value: 'MS', name: 'Mississippi' },
    { value: 'MO', name: 'Missouri' },
    { value: 'MT', name: 'Montana' },
    { value: 'NE', name: 'Nebraska' },
    { value: 'NV', name: 'Nevada' },
    { value: 'NH', name: 'New Hampshire' },
    { value: 'NJ', name: 'New Jersey' },
    { value: 'NM', name: 'New Mexico' },
    { value: 'NY', name: 'New York' },
    { value: 'NC', name: 'North Carolina' },
    { value: 'ND', name: 'North Dakota' },
    { value: 'OH', name: 'Ohio' },
    { value: 'OK', name: 'Oklahoma' },
    { value: 'OR', name: 'Oregon' },
    { value: 'PA', name: 'Pennsylvania' },
    { value: 'RI', name: 'Rhode Island' },
    { value: 'SC', name: 'South Carolina' },
    { value: 'SD', name: 'South Dakota' },
    { value: 'TN', name: 'Tennessee' },
    { value: 'TX', name: 'Texas' },
    { value: 'UT', name: 'Utah' },
    { value: 'VT', name: 'Vermont' },
    { value: 'VA', name: 'Virginia' },
    { value: 'WA', name: 'Washington' },
    { value: 'WV', name: 'West Virginia' },
    { value: 'WI', name: 'Wisconsin' },
    { value: 'WY', name: 'Wyoming' },
]

export const NETWORK_COLORS = {
    aetna: 'rgba(59, 130, 246, 0.7)',
    bcbsil: 'rgba(20, 184, 166, 0.7)',
    bcbstx: 'rgba(34, 197, 94, 0.7)',
    cigna: 'rgba(168, 85, 247, 0.7)',
    ehn: 'rgba(249, 115, 22, 0.7)',
    first_health: 'rgba(234, 179, 8, 0.7)',
    health2business: 'rgba(20, 184, 166, 0.7)',
    healthlink: 'rgba(139, 92, 246, 0.7)',
    healthsmart: 'rgba(239, 68, 68, 0.7)',
    multiplan: 'rgba(16, 185, 129, 0.7)',
    regence_bcbs_ut: 'rgba(99, 102, 241, 0.7)',
    selecthealth: 'rgba(245, 158, 11, 0.7)',
    united_optum: 'rgba(244, 114, 182, 0.7)',
}
